import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import Config from "config";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import {
  FiCalendar,
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
} from "react-icons/fi";
function NewReservation() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const urlParams = new URLSearchParams(window.location.search);

  const investisseurId = urlParams.get("investisseur_id");
  const partenaireId = urlParams.get("partenaire_id");

  const investisseurName = urlParams.get("investisseur_name");
  const [isReservationAccordionOpen, setIsReservationAccordionOpen] =
    useState(true);
  const toggleReservationAccordion = () =>
    setIsReservationAccordionOpen((o) => !o);
  const [isCumulsAccordionOpen, setIsCumulsAccordionOpen] = useState(true);
  const toggleCumulsAccordion = () => setIsCumulsAccordionOpen((o) => !o);
  const [isDossierAccordionOpen, setIsDossierAccordionOpen] = useState(true);
  const toggleDossierAccordion = () => setIsDossierAccordionOpen((o) => !o);
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");

  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
      marginTop: "-8px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "#fff", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [reservationsData, setReservationsData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  /*************************   Cumuls *******************************/
  const [souscriptionsEnCours, setSouscriptionsEnCours] = useState("0");
  const [souscriptionsRealisees, setSouscriptionsRealisees] = useState("0");
  const [remboursementRompus, setRemboursementRompus] = useState("0");
  const [montantRestant, setMontantRestant] = useState("0");
  const handleSouscriptionsEnCoursChange = (e) => {
    setSouscriptionsEnCours(e.target.value);
  };

  const handleSouscriptionsRealiseesChange = (e) => {
    setSouscriptionsRealisees(e.target.value);
  };

  const handleRemboursementRompusChange = (e) => {
    setRemboursementRompus(e.target.value);
  };

  const handleMontantRestantChange = (e) => {
    setMontantRestant(e.target.value);
  };

  /*************************   End Cumuls *******************************/
  /*************************   Statut *******************************/
  const [statutData, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/statuts_reservations`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setStatutData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statutData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  function formatDateToFrench(inputDate) {
    // Crée un objet Date à partir de la date d'entrée
    const date = new Date(inputDate);

    // Extrayez le jour, le mois et l'année de l'objet Date
    const day = date.getDate();
    const month = date.getMonth() + 1; // Les mois sont indexés à partir de zéro, donc ajoutez 1
    const year = date.getFullYear();

    // Formate la date en format français (DD/MM/YYYY)
    const formattedDate = `${day.toString().padStart(2, "0")}/${month
      .toString()
      .padStart(2, "0")}/${year}`;

    return formattedDate;
  }

  /************************* Partenaire *******************************/
  const [partenairesData, setPartenairesData] = useState({ data: [] });
  const [selectedPartenaire, setSelectedPartenaire] = useState("");
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/partenaires`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setPartenairesData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: partenairesData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Partenaire *******************************/
  /*************************   Investisseurs  *******************************/
  const [investisseursData, setInvestisseursData] = useState({ data: [] });
  const [selectedInvestisseur, setSelectedInvestisseur] = useState("");
  const handleInvestisseurChange = (e) => {
    setSelectedInvestisseur(e);
  };
  const getInvestisseurs = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/investisseurs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((mode) => {
          setInvestisseursData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseursOptions = () => {
    return [
      {
        options: investisseursData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Investisseurs *******************************/
  /*************************   Catégorie PME  *******************************/
  const [selectedCategorie, setSelectedCategorie] = useState({
    label: "DOM COM",
    value: 1,
  });
  const [categorieData, setCategorieData] = useState({ data: [] });
  const handleCategorieChange = (e) => {
    setSelectedCategorie(e);
  };
  const getCategories = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/reservations/natures_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((categorie) => {
          setCategorieData(categorie);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCategorieOptions = () => {
    return [
      {
        options: categorieData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   END Catégorie *******************************/
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Année   *******************************/
  const [selectedAnnee, setSelectedAnnee] = useState("");
  const [anneeData, setAnneeData] = useState({ data: [] });
  const handleAnneeChange = (e) => {
    setSelectedAnnee(e);
  };
  const getAnnee = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/annees`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setAnneeData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderAnneeOptions = () => {
    return [
      {
        options: anneeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear(); // On récupère juste l'année
    return `${year}`;
  };

  useEffect(() => {
    if (anneeData && anneeData.data && anneeData.data.length > 0) {
      const currentYear = getCurrentDate();

      // Accéder aux options dans anneeData.data[0].options
      const options = renderAnneeOptions()?.[0].options;

      // Rechercher l'option dont le label correspond à l'année courante
      const currentYearOption = options.find(
        (option) => option.label === currentYear
      );

      // Si l'option correspondant à l'année courante existe, définir l'année par défaut
      if (currentYearOption) {
        setSelectedAnnee(currentYearOption); // Utiliser .value pour la sélection
      }
    }
  }, [anneeData]);
  useEffect(() => {
    if (
      partenairesData &&
      partenairesData.data &&
      partenairesData.data.length > 0
    ) {
      // Accéder aux options dans anneeData.data[0].options
      const options = renderPartenaireOptions()?.[0].options;
      // Rechercher l'option dont le label correspond à l'année courante
      const partenaire = options.find((option) => option.value == partenaireId);

      // Si l'option correspondant à l'année courante existe, définir l'année par défaut
      if (partenaire) {
        setSelectedPartenaire(partenaire); // Utiliser .value pour la sélection
      }
    }
  }, [partenairesData]);
  console.log(selectedPartenaire);
  /*************************   END Année *******************************/
  /*************************   Taux d'apport  *******************************/
  const [selectedTaux, setSelectedTaux] = useState("");
  const [tauxData, setSelectedTauxData] = useState({ data: [] });
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/reservations/taux_apports`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((taux) => {
          setSelectedTauxData(taux);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /******************************* END Taux d'apport *******************************************/
  /*************************   Montant *******************************/
  const [selectedMontant, setSelectedMontant] = useState("");
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };

  /*************************   END Montant  *******************************/
  /*************************   Date d'engagement et limite *******************************/
  const [selectedDateEngagement, setSelectedDateEngagement] = useState("");
  const [selectedDateLimite, setSelectedDateLimite] = useState("");

  /*************************   END date d'engagement   *******************************/
  /*************************   Complément  *******************************/
  const [selectedComplement, setSelectedComplement] = useState("");
  const handleComplementChange = (e) => {
    setSelectedComplement(e.target.value);
  };
  /************************* END Complément   *******************************/

  /******************************* Date de signature *******************************************/
  const [selectedDateSignature, setSelectedDateSignature] = useState("");
  /******************************* END date de signature *******************************************/
  /******************************* Lieu de signature *******************************************/
  const [selectedLieuSignature, setSelectedLieuSignature] = useState("");
  const handleLieuChange = (e) => {
    setSelectedLieuSignature(e.target.value);
  };
  /******************************* END Lieu *******************************************/
  /******************************* Mode de règlement *******************************************/
  const [selectedMode, setSelectedMode] = useState("");
  const [modeData, setModeData] = useState({ data: [] });
  const handleModeChange = (e) => {
    setSelectedMode(e);
  };

  const getMode = async () => {
    try {
      await fetch(
        `https://www.fluxod.com/${api}/reservations/mode_reglements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((mode) => {
          setModeData(mode);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeOptions = () => {
    return [
      {
        options: modeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* END Mode de règlement *******************************************/
  /******************************* IBAN *******************************************/
  const [selectedIban, setSelectedIban] = useState("");
  const handleIbanChange = (e) => {
    setSelectedIban(e.target.value);
  };
  /******************************* END IBAN *******************************************/
  /******************************* BIC *******************************************/
  const [selectedBic, setSelectedBic] = useState("");
  const handleBicChange = (e) => {
    setSelectedBic(e.target.value);
  };
  /******************************* END BIC *******************************************/
  /******************************* RUM *******************************************/
  const [selectedRum, setSelectedRum] = useState("");
  const handleRumChange = (e) => {
    setSelectedRum(e.target.value);
  };
  /******************************* END RUM *******************************************/
  /******************************* Date prelevement *******************************************/
  const [selectedDatePrelevement, setSelectedDatePrelevement] = useState("");
  const handleDatePrelevementChange = (e) => {
    setSelectedDatePrelevement(e.target.value);
  };
  /******************************* END Date prelevement *******************************************/
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmitPP = async (event) => {
    event.preventDefault();
    if (
      selectedPartenaire === null ||
      (selectedPartenaire === "" && selectedStatut === null) ||
      (selectedStatut === "" && selectedTaux === null) ||
      (selectedTaux === "" && selectedAnnee === null) ||
      (selectedAnnee === "" && selectedCategorie === null) ||
      selectedCategorie === ""
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else if (
      selectedPartenaire === null ||
      (selectedPartenaire === "" && selectedStatut === null) ||
      selectedStatut === ""
    ) {
      toast.error("Le statut et le partenaire ne peuvent pas être vide");
    } else if (selectedTaux === null || selectedTaux === "") {
      toast.error("Le taux ne peut pas être vide");
    } else if (selectedAnnee === null || selectedAnnee === "") {
      toast.error("L'année ne peut pas être vide");
    } else if (selectedPartenaire === null || selectedPartenaire === "") {
      toast.error("Le partenaire ne peut pas être vide");
    } else if (selectedStatut === null || selectedStatut === "") {
      toast.error("Le statut ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/reservations`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              reservation: {
                partenaire_id: selectedPartenaire?.value,
                investisseur_id: selectedInvestisseur?.value,
                natures_investissement_id: selectedCategorie?.value,
                montant: selectedMontant,
                statuts_reservation_id: selectedStatut?.value,
                date_limite_confirmation: selectedDateLimite,
                date_engagement_ferme: selectedDateEngagement,
                taux_apport_id: selectedTaux?.value,
                pme_id: selectedPme?.value,
                annee_id: selectedAnnee?.value,
                complement_dinformations: selectedComplement,
                lieu_de_signature: selectedLieuSignature,
                date_de_signature: selectedDateSignature,
                mode_reglement_id: selectedMode?.value,
                iban: selectedIban,
                bic: selectedBic,
                rum: selectedRum,
                date_prelevement: selectedDatePrelevement,
              },
            }),
          }
        );

        if (response.ok) {
          console.log("Post request successful");
          const responseData = await response.json();

          // localStorage.setItem("key", true);
          // localStorage.setItem("lastId", id);

          navigate(`${backUrl}${responseData.go_to}`);
          // handleNavigate();
        } else {
          console.error("Post request failed");
          const responseData = await response.json();

          if (responseData && responseData.reservation_validation) {
            // Si le champ  est présent dans la réponse JSON
            const errors = responseData?.reservation_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     await getData();
    //   } catch (error) {
    //     console.error("Error fetching data:", error);
    //   }
    // };

    // fetchData();
    if (investisseurId && investisseurName != null) {
      setSelectedInvestisseur({
        label: investisseurName,
        value: investisseurId,
      });
    }

    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  useEffect(() => {
    if (!loading) {
      getMode();
      getPartenaire();
      getStatut();
      getTaux();
      getAnnee();
      getInvestisseurs();
      getPme();
      getCategories();
    }
  }, [loading]);

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Reservations | New";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails réservation
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row className="mb-2">
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/reservations/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Reservations
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i> New
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmitPP} // validation PP
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to={`${backUrl}/reservations/`}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row className="mb-2">
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleReservationAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Réservation
                                      </span>
                                    </div>
                                    {isReservationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  {/* Contenu repliable */}
                                  <Collapse isOpen={isReservationAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Statut */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Statut*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedStatut}
                                                  onChange={handleStatutChange}
                                                  options={renderStatutOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedStatut === null ||
                                                      selectedStatut === ""
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un statut..."
                                                />
                                                {(selectedStatut === null ||
                                                  selectedStatut === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Statut ne peut pas être vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Partenaire */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Partenaire*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedPartenaire}
                                                  onChange={
                                                    handlePartenaireChange
                                                  }
                                                  options={renderPartenaireOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedPartenaire ===
                                                      null ||
                                                      selectedPartenaire === ""
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un partenaire..."
                                                />
                                                {(selectedPartenaire === null ||
                                                  selectedPartenaire ===
                                                    "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Partenaire ne peut pas être
                                                    vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Catégorie PME */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Catégorie PME*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedCategorie}
                                                  onChange={
                                                    handleCategorieChange
                                                  }
                                                  options={renderCategorieOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedCategorie ===
                                                      null ||
                                                      selectedCategorie === ""
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner une catégorie..."
                                                />
                                                {(selectedCategorie === null ||
                                                  selectedCategorie === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Catégorie ne peut pas être
                                                    vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* PME (si connue) */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  PME (si connue)
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedPme}
                                                  onChange={handlePmeChange}
                                                  options={renderPmeOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner une PME..."
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Investisseur */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Investisseur
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedInvestisseur}
                                                  onChange={
                                                    handleInvestisseurChange
                                                  }
                                                  options={renderInvestisseursOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un investisseur..."
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Année de souscription */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Année de souscription*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedAnnee}
                                                  onChange={handleAnneeChange}
                                                  options={renderAnneeOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedAnnee === null ||
                                                      selectedAnnee === ""
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner une année..."
                                                />
                                                {(selectedAnnee === null ||
                                                  selectedAnnee === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Année de souscription ne
                                                    peut pas être vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Taux d'apport */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Taux d'apport*
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="select-wrapper">
                                                <Select
                                                  value={selectedTaux}
                                                  onChange={handleTauxChange}
                                                  options={renderTauxOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedTaux === null ||
                                                      selectedTaux === ""
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                  placeholder="Sélectionner un taux..."
                                                />
                                                {(selectedTaux === null ||
                                                  selectedTaux === "") && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Taux d'apport ne peut pas
                                                    être vide
                                                  </div>
                                                )}
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Montant (€) */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Montant (€)
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedMontant
                                                    .toLocaleString("fr-FR", {
                                                      style: "currency",
                                                      currency: "EUR",
                                                    })
                                                    .replace("€", "")}
                                                  required
                                                  onChange={handleMontantChange}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding:
                                                      "0.375rem 2rem 0.375rem 0.5rem",
                                                    height: "32px",
                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                                <span
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    fontSize: "0.7rem",
                                                    pointerEvents: "none",
                                                    opacity: 0.7,
                                                  }}
                                                >
                                                  €
                                                </span>
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Date engagement ferme */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Date engagement ferme
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={selectedDateEngagement}
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  onChange={(dateString) =>
                                                    setSelectedDateEngagement(
                                                      dateString.target.value
                                                    )
                                                  }
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding:
                                                      "0.375rem 2rem 0.375rem 0.5rem",
                                                    height: "32px",
                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                                <FiCalendar
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Date limite de confirmation */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Date limite de confirmation
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <InputMask
                                                  mask="99/99/9999"
                                                  value={selectedDateLimite}
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  onChange={(dateString) =>
                                                    setSelectedDateLimite(
                                                      dateString.target.value
                                                    )
                                                  }
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding:
                                                      "0.375rem 2rem 0.375rem 0.5rem",
                                                    height: "32px",
                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                                <FiCalendar
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "50%",
                                                    transform:
                                                      "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Complément d'informations */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-start g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Complément d&apos;informations
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="textarea-wrapper position-relative">
                                                <textarea
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={
                                                    selectedComplement || ""
                                                  }
                                                  style={{
                                                    width: "100%",
                                                    resize: "vertical",
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.5rem 0.75rem",
                                                    minHeight: "70px",
                                                    transition: "all 0.2s ease",
                                                  }}
                                                  onChange={
                                                    handleComplementChange
                                                  }
                                                  onFocus={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffffff";
                                                    e.currentTarget.style.boxShadow =
                                                      "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                  }}
                                                  onBlur={(e) => {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#f8f9fa";
                                                    e.currentTarget.style.boxShadow =
                                                      "none";
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>

                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En‑tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleCumulsAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Cumuls
                                      </span>
                                    </div>
                                    {isCumulsAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  {/* Contenu repliable */}
                                  <Collapse isOpen={isCumulsAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Souscriptions en cours */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Souscriptions en cours
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  type="text"
                                                  value={souscriptionsEnCours}
                                                  onChange={
                                                    handleSouscriptionsEnCoursChange
                                                  }
                                                  disabled
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Souscriptions réalisées */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Souscriptions réalisées
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  type="text"
                                                  value={souscriptionsRealisees}
                                                  onChange={
                                                    handleSouscriptionsRealiseesChange
                                                  }
                                                  disabled
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Remboursement rompus */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Remboursement rompus
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  type="text"
                                                  value={remboursementRompus}
                                                  onChange={
                                                    handleRemboursementRompusChange
                                                  }
                                                  disabled
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Montant restant à investir */}
                                        <div
                                          className="field-item px-2 py-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            marginBottom: "1px",
                                            position: "relative",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Montant restant à investir
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <div className="input-wrapper position-relative">
                                                <input
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  type="text"
                                                  value={montantRestant}
                                                  onChange={
                                                    handleMontantRestantChange
                                                  }
                                                  disabled
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    height: "32px",
                                                    textAlign: "right",
                                                  }}
                                                />
                                              </div>
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>

                                <Col sm="12">
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En‑tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleDossierAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Dossier de souscription
                                        </span>
                                      </div>
                                      {isDossierAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    {/* Contenu repliable */}
                                    <Collapse isOpen={isDossierAccordionOpen}>
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {/* Lieu de signature */}
                                          <div
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: "3px solid #dc3545",
                                              marginBottom: "1px",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Lieu de signature
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <div className="input-wrapper position-relative">
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={
                                                      selectedLieuSignature
                                                    }
                                                    required
                                                    onChange={handleLieuChange}
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 2rem 0.375rem 0.5rem",
                                                      height: "32px",
                                                      transition:
                                                        "all 0.2s ease",
                                                    }}
                                                    onFocus={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffffff";
                                                      e.currentTarget.style.boxShadow =
                                                        "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                    }}
                                                    onBlur={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#f8f9fa";
                                                      e.currentTarget.style.boxShadow =
                                                        "none";
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* RUM */}
                                          <div
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: "3px solid #dc3545",
                                              marginBottom: "1px",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    RUM
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <div className="input-wrapper position-relative">
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedRum}
                                                    required
                                                    onChange={handleRumChange}
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 2rem 0.375rem 0.5rem",
                                                      height: "32px",
                                                      transition:
                                                        "all 0.2s ease",
                                                    }}
                                                    onFocus={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffffff";
                                                      e.currentTarget.style.boxShadow =
                                                        "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                    }}
                                                    onBlur={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#f8f9fa";
                                                      e.currentTarget.style.boxShadow =
                                                        "none";
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Date de prélèvement conditionnelle */}
                                          {selectedMode?.value === 3 &&
                                            selectedStatut?.value === 6 && (
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Date de prélèvement
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={
                                                          selectedDatePrelevement
                                                        }
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        onChange={(
                                                          dateString
                                                        ) =>
                                                          setSelectedDatePrelevement(
                                                            dateString.target
                                                              .value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiCalendar
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                          {/* Mode de règlement */}
                                          <div
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: "3px solid #dc3545",
                                              marginBottom: "1px",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Mode de règlement
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <div className="select-wrapper">
                                                  <Select
                                                    value={selectedMode}
                                                    onChange={handleModeChange}
                                                    options={renderModeOptions()}
                                                    isClearable={true}
                                                    classNamePrefix="select2-selection"
                                                    styles={styles(
                                                      selectedMode === null ||
                                                        selectedMode === ""
                                                    )}
                                                    menuPortalTarget={
                                                      document.body
                                                    }
                                                    placeholder="Sélectionner un mode..."
                                                  />
                                                  {(selectedMode === null ||
                                                    selectedMode === "") && (
                                                    <div className="invalid-feedback d-block mt-1 small">
                                                      Mode de règlement ne peut
                                                      pas être vide
                                                    </div>
                                                  )}
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* IBAN/BIC si mode = 3 */}
                                          {selectedMode?.value === 3 && (
                                            <>
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        IBAN
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedIban}
                                                        required
                                                        onChange={
                                                          handleIbanChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                          textAlign: "right",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  marginBottom: "1px",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        BIC
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedBic}
                                                        required
                                                        onChange={
                                                          handleBicChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                          textAlign: "right",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </>
                                          )}

                                          {/* Date de signature */}
                                          <div
                                            className="field-item px-2 py-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",
                                              marginBottom: "1px",
                                              position: "relative",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Date de signature
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <div className="input-wrapper position-relative">
                                                  <InputMask
                                                    mask="99/99/9999"
                                                    value={
                                                      selectedDateSignature
                                                    }
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    onChange={(dateString) =>
                                                      setSelectedDateSignature(
                                                        dateString.target.value
                                                      )
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 2rem 0.375rem 0.5rem",
                                                      height: "32px",
                                                      transition:
                                                        "all 0.2s ease",
                                                    }}
                                                    onFocus={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#ffffff";
                                                      e.currentTarget.style.boxShadow =
                                                        "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                    }}
                                                    onBlur={(e) => {
                                                      e.currentTarget.style.backgroundColor =
                                                        "#f8f9fa";
                                                      e.currentTarget.style.boxShadow =
                                                        "none";
                                                    }}
                                                  />
                                                  <FiCalendar
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewReservation;
